module.exports = __webpack_public_path__ + "img/telegram-app.89bfad19.svg";